import dayjs from 'dayjs'
import { cloneDeep } from 'lodash-es'

export function textIncludes(text = '', value = '') {
  return text.toLocaleLowerCase().includes(value.toLocaleLowerCase())
}

export const formatTime = (time: number) => {
  const dayjsTime = dayjs(time)
  const isToday = dayjsTime.isToday()
  return dayjsTime.format(isToday ? 'HH:mm' : 'MM/DD/YYYY')
}

export const formatDateTime = (time: number, format = 'MM/DD/YYYY HH:mm:ss') => {
  const dayjsTime = dayjs(time)
  return dayjsTime.format(format)
}

export async function copyText(text: string) {
  await navigator.clipboard.writeText(text)
}

export function getProjectLink(project) {}

export function options2Filters(options) {
  return options.map((option) => ({
    value: option.value,
    text: option.label
  }))
}

export function listToTree(data: any[], targetKey = 'parentId') {
  let map = {}
  let roots: any[] = []
  const list = cloneDeep(data)

  list.forEach((item, index) => {
    map[item.id] = index
  })

  list.forEach((item) => {
    const value = item[targetKey]
    const targetItem = list[map[value]]
    if (targetItem) {
      if (!targetItem.children) {
        targetItem.children = [item]
      } else {
        targetItem.children.push(item)
      }
    } else {
      roots.push(item)
    }
  })

  return roots
}

export function listToMap(list) {
  let map = {}
  list.forEach((item) => {
    map[item.id] = item
  })
  return map
}

export function treeNodePath(listMap, node) {
  let path = [node.id]
  let data = node
  while (data?.parentId) {
    data = listMap[data.parentId]
    data && path.unshift(data.id)
  }
  return path
}

export function removeTreeNodeById(tree, func) {
  tree.map((item, index) => {
    if (func(item)) {
      tree.splice(index, 1)
    }
    if (item.children) {
      removeTreeNodeById(item.children, func)
    }
  })
  return tree
}

export function findTreeNode(tree, func) {
  for (const item of tree) {
    if (func(item)) return item
    if (item.children) {
      const res = findTreeNode(item.children, func)
      if (res) return res
    }
  }
  return null
}
